import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Check if an email has orders in Shopify
 * Calls waka-agent checkOrderByEmail function
 *
 * @param {string} email - User's email address
 * @returns {Promise<{found: boolean, orderNumber?: string, orderDate?: string, lineItems?: Array}>}
 */
export const checkShopifyOrder = async (email) => {
  try {
    // Get waka-agent functions instance
    const wakaAgentFunctions = getFunctions(undefined, 'us-central1');

    // Call the checkOrderByEmail function
    const checkOrder = httpsCallable(wakaAgentFunctions, 'checkOrderByEmail');
    const result = await checkOrder({ email });

    return result.data;
  } catch (error) {
    console.error('Error checking Shopify order:', error);

    // Return not found on error (graceful degradation)
    return { found: false };
  }
};

/**
 * Check if a retailer should auto-verify
 * Known retailers don't require admin review
 *
 * @param {string} retailer - Purchase location
 * @returns {boolean}
 */
export const shouldAutoVerifyRetailer = (retailer) => {
  const autoVerifyRetailers = [
    'waka.surf',
    'MACkite',
    'Green Hat Kiteboarding'
  ];

  return autoVerifyRetailers.includes(retailer);
};

/**
 * Get verification method based on source
 *
 * @param {boolean} shopifyMatch - Whether email matched in Shopify
 * @param {string} retailer - Purchase location
 * @returns {string}
 */
export const getVerificationMethod = (shopifyMatch, retailer) => {
  if (shopifyMatch) {
    return 'shopify-auto';
  }

  if (shouldAutoVerifyRetailer(retailer)) {
    return 'retailer-auto';
  }

  return 'admin-manual';
};
